"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});
var e = {
  en: "",
  jp: "jp",
  en_CA: "ca",
  fr_CA: "ca/fr",
  mt: "mt",
  fi: "fi",
  no: "no",
  de: "de"
};

function r(e) {
  return e.endsWith("/") ? e : e + "/";
}

function n(e) {
  return e.endsWith("/") ? e.slice(0, -1) : e;
}

function t(n, t, a) {
  for (var o = arguments.length, u = new Array(o > 3 ? o - 3 : 0), c = 3; c < o; c++) {
    u[c - 3] = arguments[c];
  }

  return r(n === t ? i(a) + "/" + u.join("/") : "/" + e[n] + i(a) + "/" + u.join("/"));
}

function i(e) {
  return n(e.replace(/(\/)\/+/g, "$1"));
}

exports.addTrailingSlash = r, exports.clean = i, exports.joinPath = function () {
  for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++) {
    n[t] = arguments[t];
  }

  return r(n.map(function (e, r) {
    return 0 === r ? e.trim().replace(/[\/]*$/g, "") : e.trim().replace(/(^[\/]*|[\/]*$)/g, "");
  }).filter(function (e) {
    return e.length;
  }).join("/"));
}, exports.makeLocalizedPath = t, exports.makeLocalizedUrl = function (e, r, n, i) {
  return e + t(r, n, i);
}, exports.removeTrailingSlash = n, exports.updateUrlParameter = function (e, r, n) {
  var t = e.indexOf("#"),
      i = -1 === t ? "" : e.substr(t);
  e = -1 === t ? e : e.substr(0, t);
  var a = new RegExp("([?&])" + r + "=.*?(&|$)", "i"),
      o = -1 !== e.indexOf("?") ? "&" : "?";
  return (e = e.match(a) ? e.replace(a, "$1" + r + "=" + n + "$2") : e + o + r + "=" + n) + i;
};